import http from '@/plugs/httpServer';
import { serverName } from '@wj/common';
let feather_campus= "feather-campus"

// 列表查询
export function getSummaryList(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/itinerary/pageItinerary`,
        data: data,
    })
}
// echats列表查询
export function getEcahrtsList(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/itinerary/getPreData`,
        data: data,
    })
}
// 交流情况查询
export function getCommunicationList(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/communication/pageComm`,
        data: data,
    })
}
// 交流情况新增
export function CommunicationInsert(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/communication/insertComms`,
        data: data,
    })
}
// 交流情况编辑
export function CommunicationEdit(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/communication/updateComm`,
        data: data,
    })
}
// 交流情况删除
export function CommunicationDelete(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/communication/deleteComm`,
        data: data,
    })
}

// 招聘情况查询
export function getRecruitList(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/recruit/pageRecruit`,
        data: data,
    })
}

// 招聘情况新增
export function RecruitInsert(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/recruit/insertRecruit`,
        data: data,
    })
}
// 招聘情况新增
export function RecruitUpdate(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/recruit/updateRecruit`,
        data: data,
    })
}
// 费用情况查询
export function getFeeList(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/fee/pageFee`,
        data: data,
    })
}
// 费用情况新增
export function FeeInsert(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/fee/insertFee`,
        data: data,
    })
}
// 费用情况新增
export function FeeUpdate(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/fee/updateFee`,
        data: data,
    })
}
// 生成分析
export function getAnalyze(data: object) {
    return http({
        method: 'GET',
        url: `${feather_campus}/analyze/getAnalyze`,
        params: data,
    })
}
// 单列表查询
export function getByPage(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/deliver/pageDeliver`,
        data: data,
    })
}
// 面试结果
export function getDelState(data: object) {
    return http({
        method: 'GET',
        url: `${feather_campus}/deliver/getDelState`,
        params: data,
    })
}
// 面试结果录入
export function evaluateDelivers(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/deliver/evaluateDelivers`,
        data: data,
    })
}
// 面试结果通知
export function sendResults(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/deliver/sendResults`,
        data: data,
    })
}

// 预约通知
export function sendCheckinTip(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/deliver/sendCheckinTip`,
        data: data,
    })
}
